import { Chip } from '@/shared/ui/chip'

interface OwnerChipProps {
  /** Пусто — платформенная запись оператора; иначе id аккаунта-владельца. */
  ownerAccountId: string
  className?: string
}

// Владелец записи каталога. Пустой owner_account_id у бэка значит
// «платформенный»: заведён оператором и виден каждому приложению; id —
// клиентский, виден только этому аккаунту.
export function OwnerChip({ ownerAccountId, className }: OwnerChipProps) {
  const chipClass = className ? { className } : {}
  return ownerAccountId === '' ? (
    <Chip tone="accent" {...chipClass}>
      Платформенный
    </Chip>
  ) : (
    <Chip {...chipClass}>{ownerAccountId}</Chip>
  )
}
